import { useEffect, useState, useCallback } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import React from 'react';
const { registerCheckoutFilters } = window.wc.blocksCheckout;
hide_input_field();


export const Block = ({ checkoutExtensionData }) => {

    const { setExtensionData } = checkoutExtensionData;


    useEffect(() => {
        hide_input_field();

    },);


};

const php_cart_obejct = af_cp_php_var.cart;

document.addEventListener('DOMContentLoaded', function () {

    // Show remove item link of the cart line items.

    registerCheckoutFilters('addify-cp-cart-block', {
        cartItemClass: (value, extensions, args) => {

            const isCartContext = args?.context === 'cart';


            if (!isCartContext) {
                return value;
            }

            let car_item = args.cartItem;
            let item_key = car_item.key;

            if (php_cart_obejct[item_key]['chain_product_detail'] && php_cart_obejct[item_key]['chain_product_detail']['parent_cat_key']) {

                value = 'af-cp-cart-custom-class';

                hide_input_field();
            }

            return value;
        },
        // });

        // registerCheckoutFilters('addify-cp-cart-block', {
        showRemoveItemLink: (value, extensions, args) => {
            let car_item = args.cartItem;
            let item_key = car_item.key;

            if (php_cart_obejct[item_key]['chain_product_detail'] && php_cart_obejct[item_key]['chain_product_detail']['parent_cat_key']) {

                value = false;
                hide_input_field();
            }
            return value;

        },
    });

});


function hide_input_field() {

    for (let index = 1; index < 5; index++) {

        setTimeout(function () {

            jQuery('.af-cp-cart-custom-class .wc-block-cart-item__quantity').each(function () {
                jQuery(this).find('.wc-block-components-quantity-selector__input').prop('readonly', true);
                jQuery(this).find('.wc-block-components-quantity-selector__button--minus').hide('fast');
                jQuery(this).find('.wc-block-components-quantity-selector__button--plus').hide('fast');

            });

        }, index * 1000);
    }
}